import { useCallback, useEffect, useRef, useState } from 'react';

const usePageVisible = (visibleCallback?: any, hiddenCallback?: any) => {
  const [propertyName, setPropertyName] = useState<string>('');
  const [visibilityChangeEvent, setVisibilityChangeEvent] = useState<string>('');
  const visibleCallbackRef = useRef(visibleCallback);
  const hiddenCallbackRef = useRef(hiddenCallback);

  useEffect(() => {
    visibleCallbackRef.current = visibleCallback;
    hiddenCallbackRef.current = hiddenCallback;
  }, [visibleCallback, hiddenCallback]);

  useEffect(() => {
    const eventName =
      'hidden' in document
        ? 'hidden'
        : 'webkitHidden' in document
        ? 'webkitHidden'
        : 'mozHidden' in document
        ? 'mozHidden'
        : null;
    setPropertyName(eventName);
    setVisibilityChangeEvent(eventName.replace(/hidden/i, 'visibilitychange'));
  }, []);

  const eventCallback = useCallback(() => {
    // visible
    if (!document[propertyName] && visibleCallbackRef.current) {
      visibleCallbackRef.current();
    }

    // hidden
    if (document[propertyName] && hiddenCallbackRef.current) {
      hiddenCallbackRef.current();
    }
  }, [propertyName]);

  useEffect(() => {
    if (visibilityChangeEvent) {
      document.addEventListener(visibilityChangeEvent, eventCallback);
    }
    return () => {
      if (visibilityChangeEvent) {
        document.removeEventListener(visibilityChangeEvent, eventCallback);
      }
    };
  }, [eventCallback, visibilityChangeEvent]);
};

export default usePageVisible;
